import React, { useState } from "react";
import {
    CogIcon,
    UserIcon,
    BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link, useNavigate } from "react-router-dom";
import Stepper from "../Common/Stepper";
import { useDispatch, useSelector } from "react-redux";
import { DetailsApi, updateLastStep } from "../../services/redux/ApiActions";
import showNotification from "../../services/redux/NotifcationService";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import LogoDiv from "../Common/LogoDiv";
import logo from '../../img/BBPS_Horizontal.png'


export default function StepThreeProperitor() {

    const [cin, setCIN] = useState('L17110MH1973PLC019786')
    const details = useSelector((state) => state.details.details);
    const customerData = useSelector((state) => state.customerData.customerData);
    const containsHindu = details?.result.businessType.toLowerCase().includes("hindu");

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleCIN = (e) => {
        setCIN(e.target.value)
    }
    const handleSubmit = async () => {
        try {
            const data = await dispatch(updateLastStep('', customerData?.token_chr, customerData?.custId));
            if (data) {
                showNotification('Success', 'success')
                navigate('/Customer/Step4');
                getDetails();
            }
        } catch (error) {
            showNotification(error, 'error');
        }
    }

    const getDetails = async () => {
        // console.log(userAgent)
        const Payload = {
            "id": customerData?.custId
        }
        // console.log(Payload)
        const data = await dispatch(DetailsApi(Payload, customerData?.token_chr, "customer"));
        dispatch(setDetailsData(data))
    }
    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className="logoBG">
                    <div className="rightElement">
                        <CustomerHeader />
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                            <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                                <Stepper />
                                <div className='bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg'>
                                                           
                                    <div className="grid grid-cols-12 gap-4">
 <div className="col-span-12 md:col-span-2 lg:col-span-2">
</div>
 <div className="col-span-12 md:col-span-8 lg:col-span-8">
 <div className="py-2 text-center">
                                        <h1 className="text-xl font-semibold letter-spacing">{containsHindu ? "DIRECTOR" : "PROPRIETOR"} DETAILS

                                        </h1>
                                    </div>
                                    </div>
                                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                                    <div style={{display:'flex',justifyContent:'right',marginTop:'-5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
                                    </div>
 </div>
                                    <div className="py-2 text-center">
                                        <h1 className="text-sm text-gray-600">Please check details of your organisation

                                        </h1>
                                    </div>
                                    <div className="overflow-x-auto border rounded-md shadow-sm mt-3">
                                        <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                        Sr.No
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                        Name
                                                    </th>

                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                        PAN
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {details?.result.partners.map((partner, index) => (
                                                    <tr key={index} className="border-t">
                                                        <td className="px-3 text-sm py-4 w-100 border-r">
                                                            {index + 1}
                                                        </td>
                                                        <td className="px-3 text-sm py-4 w-100 border-r">
                                                            {partner.partnerName}
                                                        </td>
                                                        <td className="px-3 text-sm py-4 w-100 border-r">
                                                            {partner.partnerPAN}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>


                                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                                        <div className="relative text-center">
                                            <button onClick={handleSubmit} className="vtpRm-action-button">
                                                {details?.result.lastCompletedStep > 3 ? 'Proceed' : 'Proceed'}
                                            </button>
                                            {details?.result.lastCompletedStep > 3 ? <>
                                                <span className="skip-btn hover:cursor-pointer py-4 px-4" onClick={() => navigate('/Customer/Step4')} >
                                                    Skip this step
                                                </span>
                                            </> : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                        </div>
                    </div>
                </LogoDiv>
            </body>
        </>
    );
}